import Service from '@ember/service';
import { service } from '@ember/service';
import { waitForPromise } from '@ember/test-waiters';

import Utils from '../utils/utils';

export default class CdpDataService extends Service {
  @service('aditools-site') site;
  @service('aditools-analytics') analytics;
  abortController = new AbortController();

  getCdpUrl() {
    return window.location.hostname === 'localhost'
          ? `${window.location.protocol}//${window.location.host}/cdp`
          : this.site.CdpUrl;
  }

  getViewData(pstId) {
    const locale = 'en'; // Replace this by this.site.AdiLocale if we are going to use multiple locales
    return this._getFetchPromise(
      'View data',
      this._applyJsonOverrides(pstId, `${this.getCdpUrl()}/pst/view/${locale}`, true, `${this.site.PstViewUrl}/${locale}`),
    );
  }

  getCategoryData(categoryId) {
    const locale = 'en'; // Replace this by this.site.AdiLocale if we are going to use multiple locales
    return this._getFetchPromise(
      'Category data',
      this._applyJsonOverrides(categoryId, `${this.getCdpUrl()}/pst/data/${locale}`, true, `${this.site.PstDataUrl}/${locale}`),
    );
  }

  getParameterMappingData() {
    return this._getFetchPromise(
      'Parameter mapping',
      this._applyJsonOverrides('parametermapping', `${this.getCdpUrl()}/pst`, true, this.site.PstMappingUrl),
    );
  }

  _getFetchPromise(description, url) {
    const startTime = new Date().getTime();
    return waitForPromise(
      fetch(url, { signal: this.abortController.signal })
        .then((response) => {
          if (response.status !== 200) {
            throw { code: response.status, message: response.statusText };
          }
          return response.json();
        })
        .catch((error) => {
          let status = { code: error.code ? error.code : -1, message: error.message ? error.message : 'Other' };
          console.error(
            `Load of ${description} at ${url} failed: HTTP Request Failed: ${status.code} ${status.message}`,
          );
          this.loadFailAnalytics(startTime, '_getFetchPromise', status, description, url);
          return null;
        }),
    );
  }

  _applyJsonOverrides(item, defaultpath, forceunique, override) {
    const suffix = override && override.startsWith('/testdata') ? 'json' : 'js';
    let url = override ? `${override}/${item}.${suffix}` : `${defaultpath}/${item}.js`;
    return forceunique ? url + '?id=' + new Date().getTime().toString() : url;
  }

  loadFailAnalytics(startTime, source, status, description, url = null) {
    if (url === null) {
      url =
        description === 'viewData'
          ? `${this.site.CdpUrl}/pst/view/en/${description}`
          : `${this.site.CdpUrl}/pst/data/en/${description}`;
    }
    const endTime = new Date().getTime();
    const elapsedTime = +endTime - +startTime;
    this.analytics.setWebEvent(
      Utils.getToolName(),
      source,
      `Load of ${description} at ${url} failed: HTTP Request Failed: ${status.code} ${status.message}; Seconds to fail: ${elapsedTime}`,
    );
  }
}
